import * as React from "react";
import styled from "styled-components";
import { BaseLink, LinkProps } from "../BaseLink";
import { style } from "../style";
import { Tag, BaseTagProps } from "./Tag";

const TagBaseLink = styled(BaseLink)`
  display: inline-flex;
  max-width: 100%;
  color: ${style.colors.grey.darkest};
  &:hover,
  &:focus,
  &:active {
    color: ${style.colors.grey.darkest};
  }
`;

export const TagLink: React.FC<BaseTagProps & Partial<LinkProps>> = ({ children, maxWidth, ...linkProps }) => {
  return (
    <TagBaseLink
      underline
      target="_self"
      to={`https://cloud.digitalocean.com/tags/${children}`}
      aria-label={`Tag ${children}`}
      style={{ maxWidth }}
      {...linkProps}
    >
      <Tag>{children}</Tag>
    </TagBaseLink>
  );
};
